const StopLossSelfServiceDocs = () => (
    <div className="stoploss-selfservice-docs">
        <p>
            The Stop Loss HRP claims on hold report normally runs automatically every night. Use this
            page to run it on demand instead — for example, if last night's run
            was missed or needs to be redone.
        </p>
        <p>
            Running it rebuilds the report from current claims data and emails
            it to the same people who get the nightly run. It usually takes a
            few minutes to finish. The scheduled run is unchanged and will continue to run as normal.
        </p>
        <p>Only one report can run at a time, and it can't be cancelled once started.</p>
    </div>
);

export default StopLossSelfServiceDocs;
